
import { Backdrop, CircularProgress } from '@mui/material';

interface OptionsProp {
    loading: boolean
}

export const LoadingBox = ({ loading }: OptionsProp) => (
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
);
